export function getActiveUnreadDividerBeforeMessageId({
  dividerBeforeMessageId,
  firstUnreadMessageId,
}: {
  dividerBeforeMessageId: string | null;
  firstUnreadMessageId: string | null;
}) {
  return dividerBeforeMessageId ?? firstUnreadMessageId;
}
